class ProductButtons extends HTMLElement {
  static classes = {
    fixed: 'fixed',
    static: 'static',
  };
  static ISFIXED = 1;
  static ISSTATIC = 0;
  status; initialScrollTop; 

  constructor() {
    super();
    this.init();
  }
  
  init = () => {
    this.initialScrollTop = this.offsetTop;
    this.checkPosition();
    window.onscroll = () => {
      this.checkPosition();
    };
  }

  checkPosition = () => {
    const y = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    
    if (y >= this.initialScrollTop) {
      this.setStatic();
    }
    else {
      this.setFixed();
    }
  }

  setFixed = () => {
    this.classList.add(ProductButtons.classes.fixed);
    this.status = ProductButtons.ISFIXED;
  }

  setStatic = () => {
    this.classList.remove(ProductButtons.classes.fixed);
    this.status = ProductButtons.ISSTATIC;
  }
}
if (!window.customElements.get("product-buttons")) {
  window.customElements.define("product-buttons", ProductButtons);
}

class ProductAdd extends HTMLElement {
  loader; form;
  static selectors = {
    loader: '[data-spinner]',
    price: '[data-price]'
  };
  static classes = {
    hidden: 'd-none'
  }

  constructor() {
    super();
    this.init();
  }
  
  init = () => {
    this.loader = this.querySelector(ProductAdd.selectors.loader);
    this.price = this.querySelector(ProductAdd.selectors.price);
    this.form = this.closest('form');

    this.addEventListener('click', () => this.addTocart());
  }

  addTocart = () => {
    if(this.form != undefined){
      Utils.addTocart({
        form: this.form,
        before: () => {
          this.showLoader();
        },
        success: (data) => {
          this.added();
        },
        finally: () => {
          this.hideLoader();
        }
      });
    }
  }

  added = () => {
    
  }

  showLoader = () => {
    if(this.loader != undefined)
      this.loader.classList.remove(ProductAdd.classes.hidden);
    if(this.price != undefined)
      this.price.classList.add(ProductAdd.classes.hidden);
  }

  hideLoader = () => {
    if(this.loader != undefined)
      this.loader.classList.add(ProductAdd.classes.hidden);
    if(this.price != undefined)
      this.price.classList.remove(ProductAdd.classes.hidden);
  }
  
}
if (!window.customElements.get("product-add")) {
  window.customElements.define("product-add", ProductAdd);
}

class MainProduct extends HTMLElement {
  loader;

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.loader = document.querySelector('theme-loader');
  }

  update = (variant) => {
    this.showLoader();
    const url = new URL(window.location.href);
    if(variant != undefined){
      url.searchParams.set('variant', variant);
    }
    else {
      url.searchParams.delete('variant');
    }
    axios.get(url)
      .then((response) => {
        const doc = Utils.getDocument(response.data);
        this.innerHTML = doc.querySelector('main-product').innerHTML;
        window.history.replaceState(null, null, url);
      })
      .catch((error) => {
        Utils.errorHanlder(error);
      })
      .finally(() => {
        this.hideLoader();
      });
  }

  showLoader = () => {
    if(this.loader != undefined)
      this.loader.show();
  }

  hideLoader = () => {
    if(this.loader != undefined)
      this.loader.hide();
  }
}
if (!window.customElements.get("main-product")) {
  window.customElements.define("main-product", MainProduct);
}

class ProductVariant extends HTMLElement {
  product;

  constructor() {
    super();
    this.init();
  }
  
  init = () => {
    this.product = document.querySelector('main-product');
    this.addEventListener('click', (e) => this.changeVariant(e));
  }
  
  changeVariant = (e) => {
    if(e != undefined)
      e.preventDefault();
    if(this.product != undefined){
      this.product.update(this.dataset.variant);
    }
  }
}
if (!window.customElements.get("product-variant")) {
  window.customElements.define("product-variant", ProductVariant);
}

class ProductNotify extends HTMLElement {

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.addEventListener('click', (e) => this.openNotify());
  }

  openNotify = () => {
    if(window._RestockRocket != undefined){
      window._RestockRocket.openModal();
    }
  }
}
if (!window.customElements.get("product-notify")) {
  window.customElements.define("product-notify", ProductNotify);
}

class ProductThumb extends HTMLElement {
  swipers;

  connectedCallback() { 
    this.swipers = this.closest('main-product').querySelectorAll('theme-swiper');
    console.log(this.swipers);
    this.addEventListener('click', this.changeSlide.bind(this));
  }

  changeSlide = () => {
    this.swipers.forEach(element => {
      element.swiper.slideNext();
    });
  }
}
if (!window.customElements.get("product-thumb")) {
  window.customElements.define("product-thumb", ProductThumb);
}

class ProductTabLink extends HTMLElement {
  tabs;

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.tabs = document.querySelectorAll(`[data-tab-btn="${this.dataset.tab}"]`);
    this.addEventListener('click', (e) => {
      this.tabs.forEach(tab => {
        this.changeTab(tab);
      });
    });
  }

  changeTab = (tab) => {
    const bstab = bootstrap.Tab.getOrCreateInstance(tab);
    bstab.show();
  }
}
if (!window.customElements.get("product-tab-link")) {
  window.customElements.define("product-tab-link", ProductTabLink);
}
